var map = {
	"./canada.png": "d4b0",
	"./germany.png": "a0da",
	"./netherlands.png": "3514",
	"./spain.png": "d22a",
	"./sweden.png": "5dd7",
	"./usa.png": "2124"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "afd0";